export default defineAppConfig({
  datasets: {
    industries: 'https://thecompaniesapi.s3.fr-par.scw.cloud/datasets/industries.json',
    industriesNaics: 'https://thecompaniesapi.s3.fr-par.scw.cloud/datasets/industries-naics.json',
    industriesSic: 'https://thecompaniesapi.s3.fr-par.scw.cloud/datasets/industries-sic.json',
    technologies: 'https://thecompaniesapi.s3.fr-par.scw.cloud/datasets/technologies.json',
    tlds: 'https://thecompaniesapi.s3.fr-par.scw.cloud/datasets/top-level-domains.json',
  },
  defaults: { companyDomain: 'microsoft.com' },
  locales: [
    {
      code: 'en',
      icon: 'flagpack:us',
      name: 'English',
      nameAlts: [],
    },
    {
      code: 'es',
      icon: 'flagpack:es',
      name: 'Español',
      nameAlts: ['Spanish'],
    },
    {
      code: 'fr',
      icon: 'flagpack:fr',
      name: 'Français',
      nameAlts: ['French'],
    },
  ],
  ui: {
    gray: 'slate',
    primary: 'indigo',

    alert: {
      actions: 'mt-4',
      title: '-mt-0.5 mb-2 text-sm font-bold leading-5',
    },
    avatar: { rounded: 'rounded-md ring-1 ring-white dark:ring-gray-900' },
    badge: {
      base: 'font-mono',
      color: {
        black: { outline: 'ring-1 ring-inset text-gray-900 ring-gray-900 bg-gray-100 dark:text-gray-100 dark:ring-gray-100 dark:bg-gray-900' },
        gray: { outline: 'ring-1 ring-inset text-gray-700 ring-gray-700 dark:text-gray-300 dark:ring-gray-300' },
      },
    },
    button: {
      base: 'select-none',
      color: { gray: { solid: 'gradient-texture ring-texture hover:gradient-texture-reverse text-texture transition-base' } },
      default: {
        color: 'gray',
        variant: 'solid',
      },
      variant: { subtle: 'bg-{color}-50 dark:bg-{color}-400 dark:bg-opacity-10 text-{color}-500 dark:text-{color}-400 ring-1 ring-inset ring-{color}-600 dark:ring-{color}-400 ring-opacity-25 transition dark:ring-opacity-25 hover:ring-opacity-50 dark:hover:ring-opacity-50 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-600 dark:focus-visible:ring-{color}-400' },
    },
    card: {
      background: 'bg-gray-50 dark:bg-gray-950',
      base: 'shadow-texture',
      rounded: 'rounded-xl',
    },
    container: { constrained: 'max-w-8xl' },
    dashboard: { navbar: { wrapper: 'bg-white dark:bg-background' } },
    divider: { border: { base: 'opacity-50' } },
    horizontalNavigation: { wrapper: 'bg-white dark:bg-background' },
    input: {
      default: {
        color: 'gray',
        variant: 'outline',
      },
    },
    inputMenu: {
      background: 'bg-gray-50 dark:bg-gray-950 gradient-texture',
      default: {
        color: 'gray',
        variant: 'outline',
      },
      option: {
        base: 'font-mono px-3',
        empty: 'font-mono px-3',
      },
      shadow: 'shadow-md',
    },
    modal: {
      container: 'items-center',
      padding: 'p-4 sm:p-4',
      rounded: 'rounded-xl',
      wrapper: 'z-[200]',
    },
    notifications: { wrapper: 'z-[250]' },
    page: { header: { wrapper: 'pt-0' } },
    select: {
      default: {
        color: 'gray',
        variant: 'outline',
      },
    },
    selectMenu: {
      background: 'gradient-texture',
      option: {
        base: 'w-full overflow-x-auto font-mono px-2 truncate',
        empty: 'w-full overflow-x-auto font-mono px-2 truncate',
        selectedIcon: { base: 'h-4 w-4' },
      },
      shadow: 'shadow-md',
    },
    slideover: {
      background: 'bg-gray-100 dark:bg-gray-950',
      footer: {
        base: 'border-t border-gray-200 dark:border-gray-900',
        padding: 'p-4',
      },
      width: 'w-screen max-w-2xl',
      wrapper: 'z-[200]',
    },
    tooltip: {
      background: 'bg-texture-deep !bg-gray-950',
      base: 'text-sm min-h-7 px-2.5 flex items-center !z-[1000]',
      color: 'text-white dark:text-white',
      popper: {
        placement: 'top',
        strategy: 'fixed',
      },
    },
    variables: {
      dark: { background: '8 15 33' },
      light: { background: '248 250 252' },
    },
  },
  urls: {
    demo: 'https://meetings-eu1.hubspot.com/julien-le-coupanec',
    github: 'https://github.com/thecompaniesapi',
    linkedin: 'https://www.linkedin.com/company/thecompaniesapi',
    storage: 'https://thecompaniesapi.s3.fr-par.scw.cloud',
    twitter: 'https://twitter.com/thecompaniesapi',
    updates: 'https://updates.thecompaniesapi.com/changelog',
    youtube: 'https://www.youtube.com/@TheCompaniesAPI/videos?sub_confirmation=1',
  },
})
